import React, { HtmlHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import LoaderSVG from "./iconSvgs/loader";
import AssetsSVG from "./iconSvgs/assets";
import InventorySVG from "./iconSvgs/inventory";
import { CiCalendarDate } from "react-icons/ci";
import { IoQrCode } from "react-icons/io5";
import {
    PiBell,
    PiBellSimple,
    PiCalendarDotsLight,
    PiCaretCircleLeft,
    PiCaretCircleRight,
    PiChartPieSlice,
    PiClipboardTextLight,
    PiCodepenLogoLight,
    PiCurrencyCircleDollar,
    PiDownloadSimple,
    PiEnvelopeSimple,
    PiEye,
    PiEyeClosed,
    PiEyeSlash,
    PiFunnel,
    PiKanbanFill,
    PiMapPinLine,
    PiNoteDuotone,
    PiNotePencil,
    PiPlus,
    PiSidebar,
    PiSlidersHorizontal,
    PiSpeedometerLight,
    PiStorefront,
    PiTrash,
    PiUserList,
    PiUsersFourLight,
} from "react-icons/pi";
import { FaCreditCard } from "react-icons/fa6";
import { SiGooglemarketingplatform } from "react-icons/si";
import { IoPrint } from "react-icons/io5";
import { HiUsers } from "react-icons/hi2";
import { GoArrowLeft, GoArrowRight, GoEye, GoEyeClosed, GoFile, GoShieldCheck } from "react-icons/go";
import { BsBoxSeamFill, BsGraphUpArrow, BsInboxesFill, BsListCheck, BsThreeDotsVertical } from "react-icons/bs";
import { SlSettings } from "react-icons/sl";
import { MdLanguage, MdLogout, MdOutlineInventory, MdOutlineRefresh } from "react-icons/md";
import {
    IoCalendarOutline,
    IoCloseCircleOutline,
    IoSearchOutline,
    IoSettingsSharp,
    IoStatsChart,
} from "react-icons/io5";
import { MdAdsClick, MdBusinessCenter, MdPayment } from "react-icons/md";
import { HiReceiptTax, HiTemplate } from "react-icons/hi";
import { RiCalendarScheduleFill } from "react-icons/ri";
import { IoIosNotifications } from "react-icons/io";
import { GoLaw } from "react-icons/go";
import { ImExit } from "react-icons/im";
import { GrDeliver } from "react-icons/gr";
import { MdFeedback } from "react-icons/md";
import { FaStar } from "react-icons/fa";
import { FaCheck, FaHome, FaListUl, FaRegCopy, FaTags, FaTimes } from "react-icons/fa";
import { IoIosArrowDown, IoIosWarning, IoMdClose } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { GrCart, GrLocation } from "react-icons/gr";
import { RxCross2, RxThickArrowRight } from "react-icons/rx";
import ThreedoteSVG from "./iconSvgs/threedote";
import { FaDownload, FaRegSquarePlus, FaTrashCan } from "react-icons/fa6";
import { TbFilterPlus, TbLayoutKanbanFilled } from "react-icons/tb";
import { IoCheckboxOutline } from "react-icons/io5";
import {
    LuBadgeInfo,
    LuClock,
    LuEye,
    LuEyeOff,
    LuText,
    LuMail,
    LuChevronRight,
    LuChevronDown,
    LuPencil,
    LuMoreHorizontal,
    LuGripVertical,
    LuArrowUpDown,
    LuChevronUp,
    LuChevronLeft,
    LuHistory,
    LuRocket,
    LuMoon,
} from "react-icons/lu";
import { FaRegThumbsUp } from "react-icons/fa";
import { GoNumber } from "react-icons/go";
import { FcInspection } from "react-icons/fc";
import { RiCheckboxMultipleLine, RiDashboardFill } from "react-icons/ri";
import { MdOutlinePriceChange } from "react-icons/md";
import { FaSignature } from "react-icons/fa";
import { BiCategoryAlt, BiGridVertical } from "react-icons/bi";
import { GoImage } from "react-icons/go";
import { MdCheck } from "react-icons/md";
import { VscDebugRestart } from "react-icons/vsc";
import { BiChevronDown } from "react-icons/bi";
import { VscChevronDown } from "react-icons/vsc";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { LiaQuestionCircleSolid } from "react-icons/lia";
import Repeat from"./iconSvgs/repeat";
import Save from "./iconSvgs/save";
import { CiExport } from "react-icons/ci";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaPhoneFlip, FaLocationDot } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { RiAiGenerate } from "react-icons/ri";
import { BsStars } from "react-icons/bs";
import { FaDonate } from "react-icons/fa";
import { FaGratipay } from "react-icons/fa";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { MdPriceCheck } from "react-icons/md";
import { GrIntegration } from "react-icons/gr";

export type iconNames =
    | "loader"
    | "moon"
    | "warning"
    | "file"
    | "home"
    | "delete"
    | "location"
    | "dashboard"
    | "box"
    | "inventory"
    | "chart"
    | "depreciation"
    | "calendar"
    | "users"
    | "catalog"
    | "purchase"
    | "vendors"
    | "users"
    | "reports"
    | "settings"
    | "allusers"
    | "logout"
    | "notification"
    | "sidebar"
    | "search"
    | "add-filter"
    | "add"
    | "reset"
    | "close"
    | "circleright"
    | "circleleft"
    | "filter"
    | "threedote"
    | "arrowright"
    | "arrowleft"
    | "arrowup"
    | "arrowdown"
    | "arrowupdown"
    | "grlocation"
    | "cross"
    | "download"
    | "checkbox"
    | "text-field"
    | "thumbs-up"
    | "number"
    | "inspection"
    | "multiple-checkbox"
    | "price-change"
    | "signature"
    | "grid"
    | "image"
    | "workrequest"
    | "eye"
    | "eye-closed"
    | "mailbox"
    | "chevrondown"
    | "chevronright"
    | "right"
    | "tick"
    | "restart"
    | `bichevrondown`
    | `noimage`
    | `attachmentfile`
    | `list`
    | `kanban`
    | `clock`
    | `info`
    | "edit"
    | "move-horizontal"
    | "grip-vertical"
    | "bell"
    | "plus"
    | "history"
    | "dollar-sign"
    | "copy"
    | "inventory-update"
    | "question-circle-outline"
    | "category"
    | "cart"
    | "three-dots-vertical"
    | "repeat"
    | "floppy"
    | "export"
    | "qr-code"
    | "ads-click"
    | "business"
    | "tax-receipt"
    | "onlinepayment"
    | "user-schedules"
    | "template-settings"
    | "notification-settings"
    | "law"
    | "exit-settings"
    | "fullfilling-settings"
    | "print"
    | "upload"
    | "feedback"
    | "star"
    | "phone"
    | "location"
    | "mail"
    | "ai"
    | "ai-stars"
    | "marketing"
    | "donation"
    | "tip"
    | "pricing"
    | "square-plus"
    | "note"
    | "heart"
    | "heart-outline"
    | "integration"
    | "ebt"
    | "language";
interface props extends HtmlHTMLAttributes<HTMLDivElement> {
    name: iconNames;
    size?: number;
    className?: string;
    onClick?: (e: any) => void;
    title?: string;
}

const Icon: React.FC<props> = ({ title = "", children, name, size = 20, className = "", onClick, ...args }) => {
    const { t } = useTranslation("common");
    const getIconByName = (name: iconNames) => {
        switch (name) {
            case "loader":
                return <LoaderSVG size={size} />;
            case "moon":
                return <LuMoon style={{ fontSize: `${size}px` }} />;
            case "home":
                return <FaHome style={{ fontSize: `${size}px` }} />;
            case "location":
                return <PiMapPinLine style={{ fontSize: `${size}px` }} />;
            case "grlocation":
                return <GrLocation style={{ fontSize: `${size}px` }} />;
            case "box":
                return <BsBoxSeamFill style={{ fontSize: `${size}px` }} />;
            case "chart":
                return <IoStatsChart style={{ fontSize: `${size}px` }} />;
            case "depreciation":
                return <BsGraphUpArrow style={{ fontSize: `${size}px` }} />;
            //case 'calendar': return <PiCalendarDotsLight style={{ fontSize: `${size}px` }} />;
            case "calendar":
                return <CiCalendarDate style={{ fontSize: `${size}px` }} />;
            case "workrequest":
                return <LuRocket style={{ fontSize: `${size}px` }} />;
            case "users":
                return <HiUsers style={{ fontSize: `${size}px` }} />;
            case "catalog":
                return <FaTags style={{ fontSize: `${size}px` }} />;
            case "purchase":
                return <PiClipboardTextLight style={{ fontSize: `${size}px` }} />;
            case "vendors":
                return <PiStorefront style={{ fontSize: `${size}px` }} />;
            case "users":
                return <PiUserList style={{ fontSize: `${size}px` }} />;
            case "reports":
                return <PiChartPieSlice style={{ fontSize: `${size}px` }} />;
            case "settings":
                return <IoSettingsSharp style={{ fontSize: `${size}px` }} />;
            case "allusers":
                return <PiUsersFourLight style={{ fontSize: `${size}px` }} />;
            case "logout":
                return <MdLogout style={{ fontSize: `${size}px` }} />;
            case "notification":
                return <PiBellSimple style={{ fontSize: `${size}px` }} />;
            case "sidebar":
                return <PiSidebar style={{ fontSize: `${size}px` }} />;
            case "search":
                return <IoSearchOutline style={{ fontSize: `${size}px` }} />;
            case "circleright":
                return <PiCaretCircleRight style={{ fontSize: `${size}px` }} />;
            case "circleleft":
                return <PiCaretCircleLeft style={{ fontSize: `${size}px` }} />;
            case "reset":
                return <MdOutlineRefresh style={{ fontSize: `${size}px` }} />;
            case "cross":
                return <RxCross2 style={{ fontSize: `${size}px` }} />;
            case "tip":
                return <FaGratipay style={{ fontSize: `${size}px` }} />;
            case "donation":
                return <FaDonate style={{ fontSize: `${size}px` }} />;
            case "pricing":
                return <MdPriceCheck style={{ fontSize: `${size}px` }} />;
            case "warning":
                return <IoIosWarning style={{ fontSize: `${size}px` }} />;
            case "add-filter":
                return <TbFilterPlus style={{ fontSize: `${size}px` }} />;
            case "file":
                return <GoFile style={{ fontSize: `${size}px` }} />;
            case "integration":
                return <GrIntegration style={{ fontSize: `${size}px` }} />;
            case "checkbox":
                return <IoCheckboxOutline style={{ fontSize: `${size}px` }} />;
            case "text-field":
                return <LuText style={{ fontSize: `${size}px` }} />;
            case "thumbs-up":
                return <FaRegThumbsUp style={{ fontSize: `${size}px` }} />;
            case "number":
                return <GoNumber style={{ fontSize: `${size}px` }} />;
            case "inspection":
                return <FcInspection style={{ fontSize: `${size}px` }} />;
            case "multiple-checkbox":
                return <RiCheckboxMultipleLine style={{ fontSize: `${size}px` }} />;
            case "price-change":
                return <MdOutlinePriceChange style={{ fontSize: `${size}px` }} />;
            case "signature":
                return <FaSignature style={{ fontSize: `${size}px` }} />;
            case "grid":
                return <BiGridVertical style={{ fontSize: `${size}px` }} />;
            case "image":
                return <GoImage style={{ fontSize: `${size}px` }} />;
            case "right":
                return <FaCheck style={{ fontSize: `${size}px` }} />;
            case "tick":
                return <MdCheck style={{ fontSize: `${size}px` }} />;
            case "restart":
                return <VscDebugRestart style={{ fontSize: `${size}px` }} />;
            case "marketing":
                return <SiGooglemarketingplatform style={{ fontSize: `${size}px` }} />;
            case "dashboard":
                return <RiDashboardFill size={size} />;
            case "inventory":
                return <BsInboxesFill style={{ fontSize: `${size}px` }} />;
            case "threedote":
                return <ThreedoteSVG size={size} />;
            case "category":
                return <BiCategoryAlt style={{ fontSize: `${size}px` }} />;
            case "square-plus":
                return <FaRegSquarePlus style={{ fontSize: `${size}px` }} />;
            case "ebt":
                return <FaCreditCard style={{ fontSize: `${size}px` }} />;
            case "language":
                return <MdLanguage style={{ fontSize: `${size}px` }} />;
            // case "chevrondown":
            //   return (
            //     <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            //       <path
            //         d="M11.8402 1.65818L6.38589 7.11245C6.33523 7.16316 6.27508 7.20339 6.20887 7.23084C6.14265 7.25829 6.07168 7.27242 6 7.27242C5.92832 7.27242 5.85735 7.25829 5.79113 7.23084C5.72492 7.20339 5.66476 7.16316 5.61411 7.11245L0.159841 1.65818C0.0574964 1.55584 0 1.41703 0 1.27229C0 1.12756 0.0574964 0.988747 0.159841 0.886403C0.262185 0.784059 0.400994 0.726563 0.54573 0.726562C0.690467 0.726562 0.829275 0.784059 0.93162 0.886403L6 5.95546L11.0684 0.886403C11.1191 0.835727 11.1792 0.795529 11.2454 0.768103C11.3116 0.740678 11.3826 0.726562 11.4543 0.726562C11.5259 0.726562 11.5969 0.740678 11.6631 0.768103C11.7293 0.795529 11.7895 0.835727 11.8402 0.886403C11.8908 0.937079 11.931 0.99724 11.9585 1.06345C11.9859 1.12966 12 1.20063 12 1.27229C12 1.34396 11.9859 1.41492 11.9585 1.48113C11.931 1.54735 11.8908 1.60751 11.8402 1.65818Z"
            //         fill="black"
            //       />
            //     </svg>
            //   );
            case "location":
                return <FaLocationDot style={{ fontSize: `${size}px` }} />;
            case "mail":
                return <IoIosMail style={{ fontSize: `${size}px` }} />;
            case `bichevrondown`:
                return <VscChevronDown style={{ fontSize: `${size}px` }} />;
            case `noimage`:
                return <MdOutlineImageNotSupported style={{ fontSize: `${size}px` }} />;
            case `attachmentfile`:
                return <IoDocumentAttachOutline style={{ fontSize: `${size}px` }} />;
            case `list`:
                return <FaListUl style={{ fontSize: `${size}px` }} />;
            case `kanban`:
                return <PiKanbanFill style={{ fontSize: `${size}px` }} />;
            case `clock`:
                return <LuClock style={{ fontSize: `${size}px` }} />;
            case `info`:
                return <LuBadgeInfo style={{ fontSize: `${size}px` }} />;
            case "arrowdown":
                return <LuChevronDown style={{ fontSize: `${size}px` }} />;
            case "arrowup":
                return <LuChevronUp style={{ fontSize: `${size}px` }} />;
            case "arrowupdown":
                return <LuArrowUpDown style={{ fontSize: `${size}px` }} />;
            case "arrowright":
                return <LuChevronRight style={{ fontSize: `${size}px` }} />;
            case "arrowleft":
                return <LuChevronLeft style={{ fontSize: `${size}px` }} />;
            case "delete":
                return <PiTrash style={{ fontSize: `${size}px` }} title={title || t("icon.delete")} />;
            case "eye":
                return <PiEye style={{ fontSize: `${size}px` }} />;
            case "eye-closed":
                return <PiEyeSlash style={{ fontSize: `${size}px` }} />;
            case "mailbox":
                return <PiEnvelopeSimple style={{ fontSize: `${size}px` }} />;
            case "note":
                return <PiNoteDuotone style={{ fontSize: `${size}px` }} />;
            case "edit":
                return <PiNotePencil style={{ fontSize: `${size}px` }} title={title || t("icon.edit")} />;
            case "move-horizontal":
                return <LuMoreHorizontal style={{ fontSize: `${size}px` }} />;
            case "grip-vertical":
                return <LuGripVertical style={{ fontSize: `${size}px` }} />;
            case "bell":
                return <PiBell style={{ fontSize: `${size}px` }} />;
            case "filter":
                return <PiFunnel style={{ fontSize: `${size}px` }} />;
            case "download":
                return <PiDownloadSimple style={{ fontSize: `${size}px` }} />;
            case "close":
                return <IoMdClose style={{ fontSize: `${size}px` }} />;
            case "plus":
            case "add":
                return <PiPlus style={{ fontSize: `${size}px` }} />;
            case "history":
                return <LuHistory style={{ fontSize: `${size}px` }} />;
            case "dollar-sign":
                return <PiCurrencyCircleDollar style={{ fontSize: `${size}px` }} />;
            case "copy":
                return <FaRegCopy style={{ fontSize: `${size}px` }} />;
            case "inventory-update":
                return <MdOutlineInventory style={{ fontSize: `${size}px` }} />;
            case "question-circle-outline":
                return <LiaQuestionCircleSolid style={{ fontSize: `${size}px` }} />;
            case "cart":
                return <GrCart style={{ fontSize: `${size}px` }} />;
            case "three-dots-vertical":
                return <BsThreeDotsVertical style={{ fontSize: `${size}px` }} />;
            case "repeat": 
                return <Repeat size={size} />;
            case "floppy":
                return <Save size={size} />;
            case "export":
                return <CiExport style={{ fontSize: `${size}px` }} />;
            case "qr-code":
                return <IoQrCode style={{ fontSize: `${size}px` }} />;
            case "ads-click":
                return <MdAdsClick style={{ fontSize: `${size}px` }} />;
            case "business":
                return <MdBusinessCenter style={{ fontSize: `${size}px` }} />;
            case "tax-receipt":
                return <HiReceiptTax style={{ fontSize: `${size}px` }} />;
            case "onlinepayment":
                return <MdPayment style={{ fontSize: `${size}px` }} />;
            case "user-schedules":
                return <RiCalendarScheduleFill style={{ fontSize: `${size}px` }} />;
            case "template-settings":
                return <HiTemplate style={{ fontSize: `${size}px` }} />;
            case "notification-settings":
                return <IoIosNotifications style={{ fontSize: `${size}px` }} />;
            case "law":
                return <GoLaw style={{ fontSize: `${size}px` }} />;
            case "exit-settings":
                return <ImExit style={{ fontSize: `${size}px` }} />;
            case "fullfilling-settings":
                return <GrDeliver style={{ fontSize: `${size}px` }} />;
            case "print":
                return <IoPrint style={{ fontSize: `${size}px` }} />;
            case "upload":
                return <FaCloudUploadAlt style={{ fontSize: `${size}px` }} />;
            case "feedback":
                return <MdFeedback style={{ fontSize: `${size}px` }} />;
            case "star":
                return <FaStar style={{ fontSize: `${size}px` }} />;
            case "phone":
                return <FaPhoneFlip style={{ fontSize: `${size}px` }} />;
            case "ai":
                return <RiAiGenerate style={{ fontSize: `${size}px` }} />;
            case "ai-stars":
                return <BsStars style={{ fontSize: `${size}px` }} />;
            case "heart":
                return <FaHeart style={{ fontSize: `${size}px` }} />;
            case "heart-outline":
                return <FaRegHeart style={{ fontSize: `${size}px` }} />;
            default:
                return null;
        }
    };

    const getStyle = () => {
        let style: any = {};
        if (onClick) {
            style.cursor = "pointer";
        }
        return style;
    };

    return (
        <span
            title={title}
            onClick={onClick ? onClick : (e: any) => {}}
            className={`${className} ${onClick ? "cursor-pointer" : ""}`}
            style={getStyle()}
        >
            {getIconByName(name)}
        </span>
    );
};

export default Icon;
